module.exports = __webpack_public_path__ + "static/media/close.a44f1993.svg";